import React, { useState, useEffect, ReactNode } from 'react';
import { Row, Col } from 'antd';
import './ResponsiveConsoleIDELayout.css';

interface ResponsiveConsoleIDELayoutProps {
  ideComponent: ReactNode;
  consoleComponent: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const ResponsiveConsoleIDELayout: React.FC<ResponsiveConsoleIDELayoutProps> = ({
  ideComponent,
  consoleComponent,
  className = '',
  style = {}
}) => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenSize.width < 768;
  const isTablet = screenSize.width >= 768 && screenSize.width < 1024;
  const isDesktop = screenSize.width >= 1024;

  if (isMobile || isTablet) {
    // Stacked layout for mobile and tablet
    return (
      <div 
        className={`responsive-console-ide-layout stacked ${className}`}
        style={style}
      >
        <div className="console-ide-section ide-section">
          {ideComponent}
        </div>
        <div className="console-ide-section console-section">
          {consoleComponent}
        </div>
      </div>
    );
  }

  // Side-by-side layout for desktop
  return (
    <div 
      className={`responsive-console-ide-layout side-by-side ${className}`}
      style={style}
    >
      <Row gutter={16} style={{ height: '100%' }}>
        <Col span={12} className="ide-column">
          <div className="console-ide-section ide-section">
            {ideComponent}
          </div>
        </Col>
        <Col span={12} className="console-column">
          <div className="console-ide-section console-section">
            {consoleComponent}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ResponsiveConsoleIDELayout;
